import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
      main: '#326dff',
    },
    secondary: {
      main: '#f44336',
    },
  },
});